module.exports = __webpack_public_path__ + "static/media/signature.9690a5d3.svg";